import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import FileCopyIcon from '@material-ui/icons/FileCopy';

import TextField from 'core/TextField';

class TextFieldCopy extends PureComponent {
  render() {
    const { value, ...other } = this.props;
    return (
      <TextField
        inputRef={(input) => {
          this.input = input;
        }}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton>
                <CopyToClipboard text={value}>
                  <FileCopyIcon color="primary" fontSize="small" />
                </CopyToClipboard>
              </IconButton>
            </InputAdornment>
          ),
        }}
        value={value}
        onClick={() => this.input.select()}
        {...other}
      />
    );
  }
}

TextFieldCopy.propTypes = {
  value: PropTypes.string.isRequired,
};

export default TextFieldCopy;
